import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=18a5017a&scoped=true"
import script from "./Settings.ts?vue&type=script&lang=ts&external"
export * from "./Settings.ts?vue&type=script&lang=ts&external"
import style0 from "./Settings.vue?vue&type=style&index=0&id=18a5017a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a5017a",
  null
  
)

export default component.exports